'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};


// Helpers

// Styles
var _react = require('react');var _react2 = _interopRequireDefault(_react);var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);var _images_placeholder = require('../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);
var _CarouselProjectCell = require('./CarouselProjectCell.scss');var style = _interopRequireWildcard(_CarouselProjectCell);
var _constants = require('../../constants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var CarouselProjectCell = function CarouselProjectCell(props) {var _ref;
  var formatPrice = function formatPrice() {var
    isMobile = props.isMobile,price = props.price,exactPrice = props.exactPrice,translate = props.translate,locale = props.locale;
    var separator = isMobile ? ' ' : ' - ';
    var nis = String.fromCharCode(8362);
    var ltrSymbol = String.fromCharCode(8206);
    var from = locale === _constants.language.default ? 'startingFrom' : 'from';

    var formattedPrice = exactPrice ? '' +
    ltrSymbol + nis + ' ' + (0, _beautifyNumber2.default)(exactPrice) : '' +
    translate(from) + separator + nis + (0, _beautifyNumber2.default)(price);

    return formattedPrice;
  };

  var renderFavoriteIcon = function renderFavoriteIcon() {
    var handleToggleFavorite = function handleToggleFavorite(evt) {
      evt.stopPropagation();
      props.toggleFavorite(evt);
    };

    return (
      _react2.default.createElement('span', {
          onClick: handleToggleFavorite,
          className: (0, _classnames2.default)(
          style.favoriteIcon,
          'favoriteToggler',
          props.isFavorite ? 'icon-favorite-active-with-border' : 'icon-favorite-disabled') },


        _react2.default.createElement('span', { className: 'path1 favoriteToggler' }),
        _react2.default.createElement('span', { className: 'path2 favoriteToggler' })));


  };

  return (
    _react2.default.createElement('div', { className: style.propertyRow },
      _react2.default.createElement('div', null,
        _react2.default.createElement('div', { className: (0, _classnames2.default)(style.propertyCellPhotoBlock) },
          _react2.default.createElement('img', _extends({
            alt: '',
            property: 'photo',
            className: (0, _classnames2.default)({ 'swiper-lazy': props.isLazy }) }, (_ref = {}, _ref[
          props.isLazy ? 'data-src' : 'src'] = props.image || _images_placeholder2.default, _ref))),

          renderFavoriteIcon(),
          _react2.default.createElement('div', { className: style.propertyPrice }, formatPrice()))),


      _react2.default.createElement('div', { className: style.propertyDescription },
        _react2.default.createElement('div', null,
          _react2.default.createElement('div', { className: style.propertyType }, props.translate('header', 'projects')),
          _react2.default.createElement('div', { className: style.propertyAddress },
            _react2.default.createElement('div', { className: style.projectName }, props.name),
            _react2.default.createElement('div', { className: style.projectAddress },
              props.address.street_name, '\xA0', props.address.house_number, ','),

            _react2.default.createElement('div', null, props.address.city_name))),


        _react2.default.createElement('div', { className: props.isMobile && style.propertyAddress }, _react2.default.createElement('b', null, props.translate('status'), ':\xA0'), props.status))));



};


CarouselProjectCell.propTypes = {
  isMobile: _propTypes2.default.bool,
  image: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  price: _propTypes2.default.number,
  exactPrice: _propTypes2.default.number,
  name: _propTypes2.default.string,
  summary: _propTypes2.default.string,
  address: _propTypes2.default.object,
  status: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  isLazy: _propTypes2.default.bool,
  toggleFavorite: _propTypes2.default.func,
  isFavorite: _propTypes2.default.bool };exports.default =


CarouselProjectCell;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CarouselProjectCell/CarouselProjectCell.js
// module id = 2617
// module chunks = 0